import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  firstName?: null | string;
  lastName?: null | string;
};

export const useGetUserLastNameWithFallback = () => {
  const { t } = useTranslation();

  return useCallback(
    ({ firstName, lastName }: P) => {
      if (lastName) {
        return lastName;
      }

      return firstName ? '' : t('user');
    },
    [t],
  );
};
